export default {
  name: 'UiDuniaBaseField',
  functional: true,
  render(h, context) {
    return context.slots().default[0];
  },
};
